import { render, staticRenderFns } from "./PaymentCollection.vue?vue&type=template&id=3e4ed3af"
import script from "./PaymentCollection.vue?vue&type=script&lang=js"
export * from "./PaymentCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports